import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCommunications = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#c9e47b",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 3.20005,
		y: 1,
		width: 9.6,
		height: 14,
		rx: 1.5,
		fill: "currentColor",
		fillOpacity: .25,
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 6.20105,
		y: 2.64905,
		width: 3.59802,
		height: 1.49695,
		rx: .748474,
		fill: "currentColor"
	})]
});
export default SvgCommunications;
